/**
 * To have NULLABLE PropType, e.g. string | null
 * Taken from https://github.com/davidje13/prop-types-nullable/blob/master/index.js
 */
export const isPropTypeNullable = (subRequirement: any) => {
  const check = (required: any, props: any, key: any, ...rest: any[]): any => {
    if (props[key] === null) {
      return null;
    }
    const sub = required ? subRequirement.isRequired : subRequirement;
    return sub(props, key, ...rest);
  };

  const fn: any = check.bind(null, false);
  fn.isRequired = check.bind(null, true);

  return fn;
};
